import React, { useContext } from 'react';
import '../../ui-styles/bottomSlider/BottomDeleteSlide.css';
import { LangCtx } from "../context";

const BtmDeleteSlide = (props) => {
    const { l } = useContext(LangCtx);

    return <div className={props.slideD ? "btmEDSlider slideUp" : "btmEDSlider"}>
        <div className="btmEDCntnr">
            <div className="btmSliderGroup">
                <div className="btnSlideItem">
                    <span className="alertTxt">{props.txt}</span>
                </div>
                <div className="btnSlideItem" onClick={props.handleConfirm}>
                    <span className="btmTxtDanger">{props.oktxt ? props.oktxt : l.delete}</span>
                </div>
            </div>
            <div className="btmSliderClose" onClick={props.handleCancel}>
                <span className="btmTxtDft">{props.canceltxt ? props.canceltxt : l.cancel}</span>
            </div>
        </div>
    </div>

}

export default BtmDeleteSlide;
